import moment from 'moment'
import {BASIC,JPT_URL} from "@/config/constant"

export const DATE_FORMAT = 'YYYY-MM-DD';
export const DATETIME_FORMAT = 'YYYY-MM-DD HH:mm:ss';
/**
 * 日期格式化,
 * 格式化成 日期 
 */
export function dateFormat(date) {
  if (date == undefined) {
   return "";
  }
  return moment(date).format(DATE_FORMAT);
}

/**
 * 日期格式化,
 * 格式化成 日期时间 
 */
export function dateTimeFormat(date) {
  if (date == undefined) {
   return "";
  }
  return moment(date).format(DATETIME_FORMAT);
}

// 日期格式化
function toFormat (fmt) {
  var o = {
    'M+': this.getMonth() + 1, // 月份
    'd+': this.getDate(), // 日
    'h+': this.getHours(), // 小时
    'm+': this.getMinutes(), // 分
    's+': this.getSeconds(), // 秒
    'q+': Math.floor((this.getMonth() + 3) / 3), // 季度
    'S': this.getMilliseconds()
    // 毫秒
  }
  if (/(y+)/.test(fmt)) {
    fmt = fmt.replace(RegExp.$1, (this.getFullYear() + '')
      .substr(4 - RegExp.$1.length))
  }
  for (var k in o) {
    if (new RegExp('(' + k + ')').test(fmt)) {
      fmt = fmt.replace(RegExp.$1, (RegExp.$1.length == 1) ? (o[k])
        : (('00' + o[k]).substr(('' + o[k]).length)))
    }
  }
  return fmt
}
/**
 * layui日期格式化 value 时间戳 format 日期格式化
 * @param value
 * @param format
 * @returns {string}
 */
export function formatTime (value, format) {
  if (value == null || value === '') {
    return ''
  }
  return toFormat.call(new Date(value), format)
}
/**
 * 生成32位UUID
 * @returns {string}
 */
export function guid () {
  var uuid36 = 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
    var r = Math.random() * 16 | 0, v = c == 'x' ? r : (r & 0x3 | 0x8)
    return v.toString(16)
  })
  var reg = new RegExp('-', 'g')// g,表示全部替换。
  var uuid32 = uuid36.replace(reg, '')
  return uuid32
}
/**
 * 判断字符串是否为空
 * @param str
 * @returns
 */
export function isNullOrEmptyStr (str) {
  if (str == null) {
    return true
  }
  if (str.trim() === '') {
    return true
  }
  return false
}
/**
 * 判断集合是否为空
 * @param arr
 * @returns
 */
export function isNullOrEmptyArr (arr) {
  if (arr == null || arr.legth === 0) {
    return true
  }
  return false
}
/**
 * 根据ID进行数据的删除
 * @param originalArr
 * @param delArr
 */
export function reomveArrById (originalArr, delArr) {
  for (var i = originalArr.length - 1; i >= 0; i--) {
    var row = originalArr[i]
    for (var j = delArr.length - 1; j >= 0; j--) {
      var delRow = delArr[j]
      if (row.id === delRow.id) {
        originalArr.splice(i, 1)
      }
    }
  }
}

/**
 * 文件预览或下载
 * @param fileId
 * @returns
 */
export function previewFile(fileId){
  var url=JPT_URL+BASIC+"/doc/preview?docId="+fileId;
  JX_download(url);
}

// 下载最新版本
function JX_download(url){
  plus.nativeUI.showWaiting( "下载中..." );
  //创建下载管理对象
  var SX_down= plus.downloader.createDownload(url,{}, function ( d, status ) {
    // 下载完成
    if ( status == 200 ) {
      plus.nativeUI.closeWaiting();
      //下载成功后的回调函数
      // plus.nativeUI.toast( "下载成功，准备安装" + d.filename );
      plus.runtime.openFile( d.filename, {}, function ( e ) {//调用第三方应用打开文件
        plus.nativeUI.toast('打开失败');
      });

    } else{
      plus.nativeUI.closeWaiting();
      plus.nativeUI.toast('下载失败');
    }
  });
  SX_down.start();
}



// WEBPACK FOOTER //
// ./src/utils/common.js